import { render, staticRenderFns } from "./Awin.vue?vue&type=template&id=7f5d2eec&"
import script from "./Awin.vue?vue&type=script&lang=js&"
export * from "./Awin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports